import React from "react";
import { indexStore } from "../../store/indexStore";
import { useNavigate } from "react-router-dom";
import QRCodeGenerator from "../QRCodeGenerator/QRCodeGenerator";
import { useTranslation } from "react-i18next";
import { downloadPDF } from "../utils/DownloadQR";
import { AlertDialogs } from "../Dialgos/Alter-Daylogs";
import EditBranchModel from "../pages/branchs/EditBranchModel";
import { Skeleton } from "../ui/skeleton";
import Visibility from "../utils/Visibility";
import { userTypes } from "src/enums/usersTpes";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Badge } from "../ui/badge";
import {
  Building2,
  Phone,
  MapPin,
  CheckCircle2,
  XCircle,
  Edit,
  Trash2,
  Download,
  QrCode,
} from "lucide-react";

export function BranchCards(props) {
  const navigate = useNavigate();
  const {
    nameLang,
    DeleteBranchesFunction,
    resetOptions,
    restDataItemsFunction,
    setBranch,
    restDataStaticsFunction,
  } = indexStore();
  const handelDeleteBranch = (id) => {
    DeleteBranchesFunction(id);
  };
  const editBranch = (element) => {
    setBranch(element);
  };
  const handelClickOnBranch = (id) => {
    resetOptions();
    restDataItemsFunction();
    restDataStaticsFunction();
    navigate(`/branches/${id}/menus`);
  };
  const { t } = useTranslation();

  const per = localStorage.getItem("role");
  const canEdit = per === userTypes.ADMIN;
  const branchName = props.element[nameLang];
  const branchAddress =
    props.element[nameLang === "name_ar" ? "address_ar" : "address_en"];

  return (
    <Card
      className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-2 hover:border-primary/20 cursor-pointer"
      onClick={() => handelClickOnBranch(props.element.id)}
      key={props.element.id}
    >
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-4 flex-1 min-w-0">
            {/* Icon */}
            <div className="p-3 rounded-xl bg-gradient-to-br from-primary/10 to-primary/5 shrink-0">
              <Building2 className="w-8 h-8 text-primary" />
            </div>

            {/* Name and Address */}
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-bold text-foreground line-clamp-1 mb-1">
                {branchName}
              </h3>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 shrink-0" />
                <span className="line-clamp-1">{branchAddress}</span>
              </div>
            </div>
          </div>

          {/* Status Badge */}
          <Badge
            variant="outline"
            className={
              props.element.active
                ? "bg-green-50 text-green-700 border-green-200 dark:bg-green-900 dark:text-green-200 shrink-0"
                : "bg-red-50 text-red-700 border-red-200 dark:bg-red-900 dark:text-red-200 shrink-0"
            }
          >
            {props.element.active ? (
              <>
                <CheckCircle2 className="w-3 h-3 mr-1" />
                {t("gloabl.active")}
              </>
            ) : (
              <>
                <XCircle className="w-3 h-3 mr-1" />
                {t("gloabl.inactive")}
              </>
            )}
          </Badge>
        </div>
      </CardHeader>

      <CardContent className="p-6 pt-4 space-y-4">
        {/* Contact Info */}
        <div className="space-y-2">
          {props.element.phone && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Phone className="w-4 h-4" />
              <span>{t("gloabl.phone")}:</span>
              <span className="font-medium text-foreground" dir="ltr">
                {props.element.phone}
              </span>
            </div>
          )}
          {props.element.mobile && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Phone className="w-4 h-4" />
              <span>{t("gloabl.mobile")}:</span>
              <span className="font-medium text-foreground" dir="ltr">
                {props.element.mobile}
              </span>
            </div>
          )}
        </div>

        {/* QR Code Section */}
        <div className="border-t pt-4 mt-4">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
              <QrCode className="w-4 h-4" />
              <span>{t("gloabl.qr_code") || "QR Code"}</span>
            </div>
          </div>
          <div className="flex justify-center bg-muted/30 p-3 rounded-lg">
            <QRCodeGenerator
              value={`https://krieshrestaurant.com/branches/${props.element.id}`}
            />
          </div>
        </div>

        {/* Actions */}
        <div
          className="flex items-center justify-between border-t pt-4 mt-4"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex gap-1">
            <Visibility visible={canEdit}>
              <EditBranchModel
                trigger={
                  <button
                    onClick={() => editBranch(props.element)}
                    className="p-1.5 rounded-lg hover:bg-muted transition-colors"
                    title={t("gloabl.edit")}
                  >
                    <Edit className="w-4 h-4 text-muted-foreground hover:text-primary" />
                  </button>
                }
              />
              <AlertDialogs
                trigger={
                  <button
                    className="p-1.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-950/30 transition-colors"
                    title={t("gloabl.delete")}
                  >
                    <Trash2 className="w-4 h-4 text-red-600" />
                  </button>
                }
                variant="icon"
                onClickOk={() => handelDeleteBranch(props.element.id)}
                description={<span>{t("gloabl.deleteMessage")}</span>}
                title={`${t("gloabl.delete")} ${t("gloabl.branch")}`}
              />
            </Visibility>
          </div>
          <button
            onClick={downloadPDF}
            className="p-1.5 rounded-lg hover:bg-muted transition-colors"
            title={t("gloabl.download") || "Download QR Code"}
          >
            <Download className="w-4 h-4 text-muted-foreground hover:text-primary" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}

export const BranchCardLoading = () => (
  <Card>
    <CardContent className="p-6">
      <div className="flex items-start gap-4 mb-4">
        <Skeleton className="w-16 h-16 rounded-xl shrink-0" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-4 w-48" />
        </div>
        <Skeleton className="h-6 w-20" />
      </div>
      <div className="space-y-2 mb-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
      <div className="border-t pt-4 space-y-3">
        <Skeleton className="h-4 w-24" />
        <div className="flex justify-center">
          <Skeleton className="w-32 h-32 rounded-lg" />
        </div>
      </div>
      <div className="flex justify-between items-center border-t pt-4 mt-4">
        <div className="flex gap-2">
          <Skeleton className="w-8 h-8 rounded-lg" />
          <Skeleton className="w-8 h-8 rounded-lg" />
        </div>
        <Skeleton className="w-8 h-8 rounded-lg" />
      </div>
    </CardContent>
  </Card>
);
